module.exports = __webpack_public_path__ + "assets/img/Type E (10).668a8f1a.jpg";